import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  getAll: function (params) {
    return axios.get(`${window.apiURL}api/gamifications/getAll`, { params })
  },
  getReward: function (params) {
    return axios.get(`${window.apiURL}api/gamifications/getReward/${params.id}`, { params })
  },
  artistShortList: function (id, params) {
    return axios.get(`${window.apiURL}api/gamifications/artistShortList/${id}`, { params })
  },
  artistList: function (params) {
    return axios.get(`${window.apiURL}api/gamifications/artistList`, { params })
  }
}



// WEBPACK FOOTER //
// ./src/services/artistGamification.js